export default __webpack_public_path__ + "static/media/controls-grey.6ef2278c.svg";